import { useState, useCallback, useLayoutEffect } from 'react';

import { useWindowResize } from './useWindowResize';

const BREAKPOINTS = {
    MOBILE: 375,
    TABLET: 768,
    SMALL_DESKTOP: 1024,
    MIDDLE_DESKTOP: 1280,
    DESKTOP: 1366,
    LARGE_DESKTOP: 1441,
    EXTRA_LARGE_DESKTOP: 1920,
} as const;

export enum ScreenSize {
    Mobile = BREAKPOINTS.MOBILE,
    Tablet = BREAKPOINTS.TABLET,
    SmallDesktop = BREAKPOINTS.SMALL_DESKTOP,
    MiddleDesktop = BREAKPOINTS.MIDDLE_DESKTOP,
    Desktop = BREAKPOINTS.DESKTOP,
    LargeDesktop = BREAKPOINTS.LARGE_DESKTOP,
    ExtraLargeDesktop = BREAKPOINTS.EXTRA_LARGE_DESKTOP,
}

export const useGetScreenSize = (): ScreenSize => {
    const [screenSize, setScreenSize] = useState<ScreenSize>(ScreenSize.Desktop);

    const updateScreenSize = useCallback(() => {
        const width = window.innerWidth;

        if (width < BREAKPOINTS.TABLET) {
            setScreenSize(ScreenSize.Mobile);
        } else if (width < BREAKPOINTS.SMALL_DESKTOP) {
            setScreenSize(ScreenSize.Tablet);
        } else if (width < BREAKPOINTS.MIDDLE_DESKTOP) {
            setScreenSize(ScreenSize.SmallDesktop);
        } else if (width < BREAKPOINTS.DESKTOP) {
            setScreenSize(ScreenSize.MiddleDesktop);
        } else if (width < BREAKPOINTS.LARGE_DESKTOP) {
            setScreenSize(ScreenSize.Desktop);
        } else if (width < BREAKPOINTS.EXTRA_LARGE_DESKTOP) {
            setScreenSize(ScreenSize.LargeDesktop);
        } else {
            setScreenSize(ScreenSize.ExtraLargeDesktop);
        }
    }, []);

    useWindowResize(updateScreenSize);

    useLayoutEffect(updateScreenSize, [updateScreenSize]);

    return screenSize;
};
